var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "24x24"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 29092",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.739 9.469h-24l2.678-9h18.55z",
    style: {
      stroke: "none"
    },
    transform: "translate(1.262 5.531)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 8.469-2.156-7H2.162l-2.083 7h21.305m1.355 1h-24l2.677-9h18.55l2.773 9z",
    style: {
      fill: "gray",
      stroke: "none"
    },
    transform: "translate(1.262 5.531)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18074",
    style: {
      stroke: "gray",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5 0h18a.5.5 0 0 1 .5.5V7H0V.5A.5.5 0 0 1 .5 0z",
    style: {
      stroke: "none"
    },
    transform: "translate(2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h18v6H.5z",
    transform: "translate(2.5)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 18075",
    d: "M0 0h1v6.5a.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5V0z",
    transform: "translate(0 15)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 18076",
    d: "M0 0h1v6.5a.5.5 0 0 1-.5.5.5.5 0 0 1-.5-.5V0z",
    transform: "translate(23 15)",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 18077",
    transform: "translate(1 18)",
    style: {
      fill: "gray"
    },
    d: "M0 0h22v1H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.4fa5976f6326afc162168eb66e6f45a1.svg";
export { ForwardRef as ReactComponent };